var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,6.4c-0.2-1-1-1.7-1.9-2C18.9,4,12,4,12,4S5.1,4,3.4,4.5c-1,0.3-1.7,1-1.9,2C1.1,8.2,1,10,1,11.8 c0,1.8,0.1,3.6,0.5,5.3c0.3,0.9,1,1.7,1.9,1.9c1.7,0.5,8.6,0.5,8.6,0.5s6.9,0,8.6-0.5c1-0.3,1.7-1,1.9-2c0.3-1.7,0.5-3.5,0.5-5.2 C23,10,22.9,8.2,22.5,6.4z M9.8,15V8.5l5.8,3.3L9.8,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.caa71e4c59982dae021d9bff13f5cdbd.svg";
export { ForwardRef as ReactComponent };